<template>
  <div class="banner">
    <div class="title">
      <h1>{{ title }}</h1>
      <h3>{{ desc }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner-title",
  props: {
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  .title {
    color: #ffffff;
    font-size: 1.3rem;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/banner-title.vue